export default "__VITE_ASSET__D2gbAzDw__"